import React from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import CreatePosition from './createPositions'
import { makeSideBarActive } from "../../utils/ellowutils";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { useNavigate } from 'react-router-dom';
import { useState , useEffect } from 'react';
import * as Utils from '../../utils/ellowutils';
import NotificationAlert from '../../compopnents/notification';
import { getPostPositions , submitValues } from './services'
import { EditorState } from 'draft-js';
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';



function CreatePositions() {

  const navigate = useNavigate()

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
  const BreadcrumsValues = ['Positions', 'Create Positions']
  const loginId = localStorage.getItem('loginId')
  const customerMetadata = JSON.parse(localStorage.getItem('customerMetdata') || '')
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty());
  const [resourceCount , setResourceCount] = useState<string>()
  const [contractDuration , setContractDuration] = useState<string>()    
  const [minimumBudget , setMinimumBudget] = useState<string>() 
  const [maximumBudget , setMaximumBudget] = useState<string>() 
  const [checked, setChecked] = useState<boolean>(false);
  const [experienceRange, setExperienceRange] = useState<{min?: number , max?: number}>({min: 0 , max: 20});
  const [postPosition, setPostPosition] = useState<[{companyName: string ; companyId: string}]>([{companyName: '' , companyId: ''}])
  const [notification, setNotification] = useState<boolean>(false)
  const [disable , setDisable] = useState<boolean>(false)
  const [disableSaveButton , setDisableSaveButton ] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [error, setError] = useState<{ startDate?: string}>({ startDate: ""});
  
  useEffect(() => {
    getPostPositions().then((response: any) => {
      if(response.status === 1){
        setPostPosition(response.data)
      }
    })
    viewedpageMixpanel();

  }, []);

  const submitData = (data: any) => {
    
    submitValues(data).then((response: any) => {
      if (response && response.status === 1) {
        mixpanelData(`MT-Position ${data.action}ed` , {
          'source': 'Recruiter creates a position',
          'title': data.jobMetadata && data.jobMetadata.title,
          'resource_count': data.jobMetadata && data.jobMetadata.resourceCount,
          'experience': data.jobMetadata && data.jobMetadata.experienceRange && data.jobMetadata.experienceRange.max + ' - ' + data.jobMetadata && data.jobMetadata.experienceRange && data.jobMetadata.experienceRange.min,
          'jobRole': data.jobMetadata && data.jobMetadata.jobRole && data.jobMetadata.jobRole.name,
          'type_0f_job': data.jobMetadata && data.jobMetadata.jobType,
          'priority': data.jobMetadata && data.jobMetadata.priority,
        //  'core_skills':  skills && skills.toString(),
          'contract_period': data.jobMetadata && data.jobMetadata.contractDuration,
          'contractStartDate': data.jobMetadata && data.jobMetadata.contractStartDate,
          'billingType': data.jobMetadata && data.jobMetadata.billingType,
          'currencyType': data.jobMetadata && data.jobMetadata.currencyType,
          'maximumBudget': data.jobMetadata && data.jobMetadata.maximumBudget,
          'minimumBudget': data.jobMetadata && data.jobMetadata.minimumBudget,    
        })
        mixpanelData(`New MT - Position ${data.jobId ? 'updated' : 'added'}`, {
          'distinct_id': localStorage.getItem('Email'),
          'Company name': customerMetadata && customerMetadata.companyName,                    
          'Job id': data.jobId !== '' ? data.jobId : response.data[0].jobId,
          'Position name': data.jobMetadata && data.jobMetadata.title,
          'Resource count': data.jobMetadata && data.jobMetadata.resourceCount,
          'Job role': data.jobMetadata && data.jobMetadata.jobRole && data.jobMetadata.jobRole.name,
          'Job type': data.jobMetadata && data.jobMetadata.jobType,
          'Experience': data.jobMetadata && data.jobMetadata.experienceRange && data.jobMetadata.experienceRange.min + ' - ' + data.jobMetadata.experienceRange.max + ' Years',
          'Priority': data.jobMetadata && data.jobMetadata.priority === 1 ? 'Cold' : data.jobMetadata.priority === 2 ? 'Warm' : 'Hot',
          'Core skills': data.jobMetadata && data.jobMetadata.coreSkills && data.jobMetadata.coreSkills.length > 0 && data.jobMetadata.coreSkills.map((item: any) => item.skillName),
          'Other skills': data.jobMetadata && data.jobMetadata.otherSkills && data.jobMetadata.otherSkills.length > 0 && data.jobMetadata.otherSkills.map((item: any) => item.skillName),

          'Contract period': data.jobMetadata && data.jobMetadata.contractDuration,
          'Contract start date': data.jobMetadata && data.jobMetadata.contractStartDate && new Date(data.jobMetadata.contractStartDate).toDateString(),
          'Maximum Budget': `${data.jobMetadata && data.jobMetadata.maximumBudget} ${data.jobMetadata && data.jobMetadata.currencyType} ${data.jobMetadata && data.jobMetadata.billingType}`,
          'Minimum Budget': `${data.jobMetadata && data.jobMetadata.minimumBudget} ${data.jobMetadata && data.jobMetadata.currencyType} ${data.jobMetadata && data.jobMetadata.billingType}`,
          'Allocated to': response && response.data[0].allocatedTo ? response.data[0].allocatedTo : 'Not mentioned',
          'Active positions': parseInt(data.jobMetadata.resourceCount) - parseInt(data.jobMetadata.closedCount),
          'Customer id': localStorage.getItem('customerId')
        })
        displayNotification(data.action)
        
        setDisable(false)
        setDisableSaveButton(false)
      }
    })
  }

  
  const publish = (value: any) => {
    
    setDisable(true)
    let finalValue = {
      userLoginId: loginId,
      jobId: value.jobId !== '' ? value.jobId : "" ,
      action: "publish",
      submittedBy: "CUSTOMER",
      jobMetadata: {
        postPosition:  value.data.postPosition,
        title:  value.data.title,
        resourceCount: value.data.resources ? value.data.resources : 0,
        jobRole: value.data.jobRole,
        jobType: value.data.jobType ? value.data.jobType : "",
        experienceRange : experienceRange,
        locationPreference: value.data.locationPreference,
        priority: value.data.priority ? value.data.priority.id : 2,
        coreSkills: value.data.coreSkills,
        otherSkills: value.data.otherSkills ? value.data.otherSkills : [],
        supportingDocument: value.data.supportingDocument? value.data.supportingDocument : "",
        contractDuration: value.data.contractDuration ? value.data.contractDuration : "",
        billingType: value.data.billingType ? value.data.billingType : "",
        currencyType: value.data.currencyType ? value.data.currencyType : "",
        minimumBudget: value.data.minimumBudget ? parseInt(value.data.minimumBudget) : "",
        maximumBudget: value.data.maximumBudget ? parseInt(value.data.maximumBudget) : "",
        jobDescription: value.data.jobDescription ?  value.data.jobDescription : "",
        contractStartDate: value.data.startDate ? value.data.startDate : 0,
        closedCount: 0,
        lossCount: 0,
        noticePeriod: value.data.noticePeriod ? value.data.noticePeriod : 0

      }
    }           
    submitData(finalValue)
  }

  
  const save = (value: any) => {

    setDisableSaveButton(true)
    let finalValue = {
      userLoginId: loginId,
      jobId: value.jobId !== '' ? value.jobId : "" ,
      action: "draft",
      submittedBy: "CUSTOMER",
      jobMetadata: {
          postPosition:  value.data.postPosition,
          title:  value.data.title,
          resourceCount: value.data.resources ? value.data.resources : 0,
          jobRole: value.data.jobRole,
          jobType: value.data.jobType ? value.data.jobType : "",
          experienceRange : experienceRange,
          locationPreference: value.data.locationPreference,
          priority: value.data.priority ? value.data.priority.id : 2,
          coreSkills: value.data.coreSkills,
          otherSkills: value.data.otherSkills ? value.data.otherSkills : [],
          supportingDocument: value.data.supportingDocument? value.data.supportingDocument : "",
          contractDuration: value.data.contractDuration ? value.data.contractDuration : "",
          billingType: value.data.billingType ? value.data.billingType : "",
          currencyType: value.data.currencyType ? value.data.currencyType : "",
          minimumBudget: value.data.minimumBudget ? parseInt(value.data.minimumBudget) : undefined,
          maximumBudget: value.data.maximumBudget ? parseInt(value.data.maximumBudget) : undefined,
          jobDescription: value.data.jobDescription ?  value.data.jobDescription : "",
          contractStartDate: value.data.startDate ? Utils.getMilliSecUTC(value.data.startDate) : 0,
          noticePeriod: value.data.noticePeriod ? value.data.noticePeriod : 0,
          closedCount: 0,
          lossCount: 0

      }
    }    
    submitData(finalValue)
  }
  
  const changeOn = (e: any, name: any) => {
    if (name === "checked") {
      if (e.target.value === true) {
        setChecked(true);
        delete error?.startDate;
        setError({ ...error });
      } else {
        setChecked(false);
      }
    }
  }

  const changeOn2 = () => {
    setChecked(true)
  }
  
  const experienceLevel = (start: any , end: any) =>{
    let value = {
      min : start ,
      max : end
    }
    setExperienceRange(value)   
  }

  const resourceCountValue = (value: any) => {
      setResourceCount(value)
  }

  const changeHandle = (e: any, name: any) => {
    if(name === "resources")
    {
      setResourceCount(e.target.value ? Math.abs(e.target.value).toString() : '')
    } 
    if(name === "contractDuration")
    {
      setContractDuration(e.target.value ? Math.abs(e.target.value).toString() : '')
    } 
    if(name === "minimumBudget")
    {
      setMinimumBudget(e.target.value ? Math.abs(e.target.value).toString() : '')
    } 
    if(name === "maximumBudget")
    {
      setMaximumBudget(e.target.value ? Math.abs(e.target.value).toString() : '')
    }
  }

  const editorStateChange = (state: any) => {
    setEditorState(state);
  }

  
  
  const displayNotification = (action: string) => {
    if (action === 'draft') {
     setMessage('Position saved successfully')
    }
    else {
     setMessage('Position published successfully')
    }
    setNotification(true)
    setTimeout(() => {
      navigate('/positions')
      setNotification(false)
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }


  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose } closable={true} >
          {message}
          </NotificationAlert> }
      <SideMenu menu={menu}/>
      <div className="dashboardContent">
        <DashboardHeader  
            // title="Positions / Create New Position"
            searchChange={undefined}
            title={BreadcrumsValues}
        />
        <CreatePosition 
          save={save} 
          publish={publish} 
          postPositions={postPosition} 
          error={error} 
          checked={checked} 
          changeOn={changeOn}
          changeOn2={changeOn2}
          resourceCountValue={resourceCountValue}
          experienceLevel={experienceLevel}
          resourceCount={resourceCount}
          contractDuration={contractDuration}
          minimumBudget={minimumBudget}
          maximumBudget={maximumBudget}
          changeHandle={changeHandle}
          editorStateChange={editorStateChange}
          editorState={editorState}
          experienceRange={experienceRange}
          disable={disable}
          disableSaveButton={disableSaveButton}
        />
      </div>
    </section>
  )
}

export default CreatePositions